/**
 * Created by mac on 12/15/20
 */

const FogTileView = cc.Node.extend({
    ctor: function (fogTile) {
        this._super();
        this.fogTile = fogTile;

        this.setCascadeColorEnabled(true);
        this.setCascadeOpacityEnabled(true);

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.styles.Map2dView.cell);

        this.borders = [];

        this.tileView = new cc.Node();
        this.tileView.setCascadeColorEnabled(true);
        this.tileView.setCascadeOpacityEnabled(true);
        this.tileView.setContentSize2(this.getContentSize());
        this.tileView.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.tileView);

        fogTile.setView(this);

        this.onUpdateState(fogTile.state, true);

        if (fogTile.isHead && !cleverapps.config.editorMode && !fogTile.fogBlock.options.headless) {
            const mapView = Map2d.currentMap.getMapView();
            const fogBlockView = this.fogBlockView = new FogBlockView(fogTile.fogBlock);
            mapView.alignViewInGrid(fogTile.x, fogTile.y, fogBlockView);
            fogBlockView.setLocalZOrder(mapView.getFogViewLocalZOrder(fogBlockView.x, fogBlockView.y));
            mapView.cloudsAbove.addChild(fogBlockView);

            fogBlockView.onUpdateBlocker(fogTile.fogBlock.state, true);
            fogBlockView.onUpdateState(fogTile.fogBlock.state, true);
            fogBlockView.onWandsChanged(true);
        }
    },

    cleanup: function () {
        this._super();

        if (this.deferredBottomTile) {
            delete this.deferredBottomTile.onViewCreated;
            delete this.deferredBottomTile;
        }

        this.fogTile.removeView();
    },

    onOpenFogBlock: function () {
        delete this.fogBlockView;
    },

    createDecoration: function () {
        const styles = this.getStyles();
        if (!styles.fogDecors) {
            return;
        }

        const pseudo = PseudoRandom.GET("fogdecor");
        pseudo.seed(this.fogTile.x * 1000 + this.fogTile.y);
        const weighted = Object.entries(styles.fogDecors).flatMap(([key, count]) => Array(count).fill(key));
        const chosen = pseudo.choose(weighted);
        const json = this.fogTile.getFogBundle().jsons[chosen];
        if (!json) {
            return;
        }

        const decoration = this.decoration = new cleverapps.Spine(json);
        decoration.setAnimation(0, "idle", true);
        decoration.setTrackProgress(pseudo.nextDouble());

        const mapView = Map2d.currentMap.getMapView();
        mapView.alignViewInGrid(this.fogTile.x, this.fogTile.y, decoration);
        decoration.setLocalZOrder(mapView.getFogViewLocalZOrder(0, 0) - 1);
        mapView.cloudsAbove.addChild(decoration);
    },

    hideDecoration: function () {
        if (!this.decoration) {
            return;
        }

        const decoration = this.decoration;
        this.decoration = undefined;

        if (decoration.setAnimation) {
            decoration.setAnimation(0, "open", false);
            decoration.setCompleteListener(() => {
                decoration.removeFromParent();
            });
        } else {
            decoration.removeFromParent();
        }
    },

    setVisible: function (visible) {
        this._super(visible);

        if (this.decoration) {
            this.decoration.setVisible(visible);
        }
    },

    removeFromParent: function (cleanup) {
        this._super(cleanup);

        [this.fogBlockView, this.fogUnit, this.balloon, this.fogAnimation, this.light, this.groundFogFxSpine, this.decoration].filter(Boolean).forEach((child) => {
            child.removeFromParent(cleanup);
        });

        if (this.unitNode) {
            cleverapps.toArray(this.unitNode).forEach((child) => {
                child.removeFromParent(cleanup);
            });
        }

        delete this.fogBlockView;
        delete this.fogUnit;
        delete this.balloon;
        delete this.unitNode;
        delete this.fogAnimation;
        delete this.decoration;
        delete this.groundFogFxSpine;
    },

    checkTouchInside: function (touch) {
        if (this.fogUnit) {
            if (!this.isDisplayed()) {
                return false;
            }

            if (UnitView.targetContainPoint(this.fogUnit, this.fogUnit.convertTouchToNodeSpace(touch))) {
                return true;
            }
        }
        return false;
    },

    pointOfInterestsSqueeze: function () {
        if (this.fogUnit) {
            this.fogUnit.runAction(new cc.Sequence(
                new cc.ScaleTo(0.1, 1.1, 0.95),
                new cc.ScaleTo(0.1, 1, 1)
            ));
        }
    },

    onClick: function () {
        if (this.openFogAction && !this.openFogAction.isDone() || this.fogDisappearAction && !this.fogDisappearAction.isDone() || this.destructFogAction && !this.destructFogAction.isDone()) {
            return;
        }

        if (this.fogTile.fogBlock.isMoney() && this.fogTile.state === FogBlock.CANOPEN) {
            this.fogTile.fogBlock.showBuyWindow();
        } else {
            this.clickAnimation();
            cleverapps.effects.fire("fog.click");
        }
    },

    onUpdateState: function (state, silent) {
        if (!cleverapps.config.editorMode) {
            if (state >= FogBlock.CANTOPEN) {
                this.hideDecoration();
            } else if (!this.decoration) {
                this.createDecoration();
            }
        }

        const styles = this.getStyles();

        if (state === FogBlock.CANOPEN) {
            this.addBalloon();
        }

        const oldTileState = this.state;

        if (state === FogBlock.CANTOPEN || state === FogBlock.CANOPEN) {
            if (this.state !== FogTileView.GROUND_STATE) {
                this.state = FogTileView.GROUND_STATE;

                if (styles.groundStateOnly && !cleverapps.skins.getSlot("playFogDisappearEffect") && oldTileState === FogTileView.FULL_STATE) {
                    this.playFogDisappearEffect();
                } else {
                    this.showGroundStateAnimation(silent);
                }

                this.showReadyAnimation(silent);
            }
        } else if (this.state !== FogTileView.FULL_STATE) {
            this.state = FogTileView.FULL_STATE;

            if (styles.groundStateOnly && !cleverapps.skins.getSlot("showFullStateAnimationForPoi", this.fogTile.getFakeUnit())) {
                this.showGroundStateAnimation(silent);
            } else {
                this.showFullStateAnimation();
            }

            this.updateBorders(silent);
        }

        if (state === FogBlock.NOTREADY) {
            this.updateBorders(silent);
        }
    },

    showReadyAnimation: function () {
        if (!this.unitNode) {
            return;
        }

        cleverapps.toArray(this.unitNode).forEach((node) => {
            const unitImage = node.unitImage;

            const playAnimation = function (image) {
                image.hasAnimation("ready_fog") && image.setAnimation(0, "ready_fog", true);
            };

            if (unitImage instanceof cleverapps.Spine) {
                playAnimation(unitImage);
            } else if (unitImage instanceof LazyAsset && unitImage.isSpine()) {
                unitImage.whenAssetLoaded(() => playAnimation(unitImage));
            }
        });
    },

    showPointOfInterest: function () {
        if (this.getFogSpineJson()) {
            return;
        }

        const styles = this.getStyles();
        const visibleUnit = this.fogTile.getFakeUnit();
        if (visibleUnit.head) {
            return;
        }

        if (this.sprite) {
            this.sprite.removeFromParent();
            this.sprite = undefined;
        }

        this.fogUnit = new cc.Node();
        this.fogUnit.setCascadeOpacityEnabled(true);
        this.fogUnit.setCascadeColorEnabled(true);

        const poiAnimation = styles.pointsOfInterest.animation || cleverapps.skins.getSlot("getPoiAnimation", visibleUnit);
        const unitImage = this.fogUnit.unitImage = UnitView.getUnitImage(visibleUnit, {
            keepLazy: true,
            defaultAnimation: poiAnimation,
            alignAnchorX: true,
            alignAnchorY: true
        });
        this.fogUnit.setAnchorPoint(unitImage.anchorX, unitImage.anchorY);
        this.fogUnit.setContentSize(unitImage.getContentSize());
        unitImage.setAnchorPoint(0.5, 0.5);
        unitImage.setAlignment(this.fogUnit.width / 2, this.fogUnit.height / 2);
        this.fogUnit.addChild(unitImage);

        this.placeFogUnit(visibleUnit);

        if (styles.pointsOfInterest.likeGroundState) {
            const unitStyles = this.getUnitStyles(visibleUnit);
            this.fogUnit.setOpacity(unitStyles.opacity);
            this.fogUnit.setColor(unitStyles.color);
            if (unitImage.clearTrack) {
                unitImage.clearTrack(0);
            }
        }

        MultiCellView(visibleUnit, this.fogUnit);
    },

    placeFogUnit: function (visibleUnit) {
        const styles = this.getStyles();
        const hasSpine = !!this.getFogSpineJson();
        const map = Map2d.currentMap;

        if (styles.pointsOfInterest.center && !this.noPoiFog()) {
            this.additionalClickView = this.fogUnit;
            if (hasSpine) {
                this.placeFogUnitInBottomTile(visibleUnit, true);
            } else {
                const mapView = Map2d.currentMap.getMapView();
                this.fogUnit.setAlignment(mapView.alignInGrid(this.fogTile.x, this.fogTile.y));
                this.fogUnit.setLocalZOrder(-1000000 + this.fogTile.y * map.getHeight() - this.fogTile.x);
                mapView.cloudsAbove.addChild(this.fogUnit);
            }
        } else {
            this.fogUnit.setLocalZOrder(styles.borders.center.zOrder);
            if (hasSpine) {
                this.placeFogUnitInBottomTile(visibleUnit, false);
            } else {
                this.fogUnit.setAlignment(this.tileView.width * styles.anchorX, this.tileView.height * styles.anchorY);
                this.tileView.addChild(this.fogUnit);
            }
        }
    },

    placeFogUnitInBottomTile: function (visibleUnit, center) {
        const styles = this.getStyles();
        const bottom = Unit.GetShape(visibleUnit).reduce((best, cell) => {
            if (!best || cell.y > best.y || cell.y === best.y && cell.x < best.x) {
                return cell;
            }
            return best;
        }, null);
        const cellSize = cleverapps.styles.Map2dView.cell;
        const offsetX = -(bottom.x + bottom.y) * cellSize.width / 2;
        const offsetY = -(bottom.x - bottom.y) * cellSize.height / 2;
        const bottomFogTile = Map2d.currentMap.getFog(this.fogTile.x + bottom.x, this.fogTile.y + bottom.y);
        const targetView = bottomFogTile && bottomFogTile.view || this;
        const deferred = !!bottomFogTile && !bottomFogTile.view;

        if (!deferred) {
            if (center) {
                targetView.addChild(this.fogUnit);
                this.fogUnit.setPosition(targetView.width / 2 + offsetX, targetView.height / 2 + offsetY);
            } else {
                targetView.tileView.addChild(this.fogUnit);
                this.fogUnit.setPosition(targetView.tileView.width * styles.anchorX + offsetX, targetView.tileView.height * styles.anchorY + offsetY);
            }
        } else {
            this.deferredBottomTile = bottomFogTile;
            bottomFogTile.onViewCreated = (bottomView) => {
                if (!this.fogUnit) {
                    return;
                }
                const baseX = center ? bottomView.width / 2 : bottomView.tileView.width * styles.anchorX;
                const baseY = center ? bottomView.height / 2 : bottomView.tileView.height * styles.anchorY;
                this.fogUnit.x += baseX + offsetX;
                this.fogUnit.y += baseY + offsetY;
                center ? bottomView.addChild(this.fogUnit) : bottomView.tileView.addChild(this.fogUnit);
            };
        }
    },

    noPoiFog: function () {
        return cleverapps.skins.getSlot("noPoiFog", this.fogTile.getFakeUnit());
    },

    getFogSpineJson: function () {
        return this.fogTile.getFogBundle().jsons[`spine_json_${this.fogTile.getFogKey()}`];
    },

    showFullStateAnimation: function () {
        let styles = this.getStyles();

        if (cleverapps.config.editorMode) {
            styles = cleverapps.styles.EditorFogTileView;
        }

        this.tileView.setAnchorPoint(styles.anchorX, styles.anchorY);

        const isPoi = this.fogTile.isPointOfInterest();
        if (isPoi && !cleverapps.config.editorMode && !this.fogTile.getFogBundle().name.endsWith("_imprv")) {
            this.showPointOfInterest();
        }

        if (cleverapps.config.editorMode || !isPoi || (!this.noPoiFog() && styles.pointsOfInterest.center)) {
            if (!this.fogTile.fake) {
                const spineJson = this.getFogSpineJson();
                if (spineJson) {
                    this.sprite = new cleverapps.Spine(spineJson);
                    const variants = this.sprite.listAnimations()
                        .filter((a) => a.startsWith("idle"))
                        .map((a) => a.slice("idle".length));
                    const pseudo = PseudoRandom.GET("fogtile");
                    pseudo.seed(this.fogTile.x * 1000 + this.fogTile.y);
                    const variant = pseudo.choose(variants);
                    this.sprite.setAnimation(0, `idle${variant}`, true);
                    this.sprite.fogAnimVariant = variant;
                } else {
                    this.sprite = new cc.Sprite(this.getFogImage());
                }
            } else {
                this.sprite = new cc.Node();
                this.sprite.setContentSize2(this.getContentSize());
                this.sprite.setAnchorPoint(0.5, 0.5);
            }
            if (styles.borders && styles.borders.center) {
                this.sprite.setLocalZOrder(styles.borders.center.zOrder);
                this.sprite.setAlignment(styles.borders.center);
            }

            this.tileView.addChild(this.sprite);
        }
    },

    showGroundStateAnimation: function (silent) {
        if (silent) {
            this.startFogDisappearAnimation(silent);
            return;
        }

        this.stopAllActions();
        this.fogDisappearAction = this.runAction(new cc.Sequence(
            new cc.DelayTime(this.fogTile.getOpenDelay() / 1000),
            new cc.CallFunc(() => {
                this.startFogDisappearAnimation(silent);
            })
        ));

        const styles = this.getStyles();
        if (styles && styles.whirlwind) {
            return;
        }

        const fogKey = this.fogTile.getFogKey();
        this.borders.forEach((border) => {
            cleverapps.effects.fire(`fog.hide_borders.${fogKey}`);

            border.runAction(new cc.Spawn(
                new cc.MoveBy(0.2, 0, -15),
                new cc.FadeOut(0.2)
            ));
        }, this);
    },

    getUnitStyles: function () {
        const styles = this.getStyles();
        if (styles.unitStyles) {
            return styles.unitStyles;
        }
        let unitStyles = cleverapps.styles.FogTileView.fogUnits.default;
        if (this.fogTile.fogBlock.isMoney()) {
            unitStyles = cleverapps.styles.FogTileView.moneyFogUnits.default;
        }
        return unitStyles;
    },

    oldFogDisappearAnimation: function (oldFog) {
        this.customDisappearFogUnitAnimation(oldFog);

        if (oldFog.isFogSpine) {
            oldFog.removeFromParent();
            this.playFogDisappearEffect();
            return;
        }

        const styles = this.getStyles();
        if (styles && styles.dispelling) {
            this.dispellingDisappearAnimation(oldFog, styles.dispelling);
        } else if (styles && styles.whirlwind) {
            this.windDisappearAnimation(oldFog, styles.whirlwind);
        } else {
            this.plantsDisappearAnimation(oldFog);
        }

        if (this.unitNode) {
            cleverapps.toArray(this.unitNode).forEach((node) => {
                if (node.unitImage instanceof cleverapps.Spine) {
                    node.unitImage.setVisible(false);
                }

                this.tileView.setOpacity(0);
                this.tileView.runAction(new cc.Sequence(
                    new cc.DelayTime(0.2),
                    new cc.FadeIn(0.3),
                    new cc.DelayTime(0.1),
                    new cc.CallFunc(() => {
                        node.unitImage.setVisible(true);
                    })
                ));
            });
        }

        this.playFogDisappearEffect();
    },

    playFogDisappearEffect: function () {
        cleverapps.effects.fire(`fog.disappear.${this.fogTile.getFogKey()}`);
    },

    customDisappearFogUnitAnimation: function (oldFog) {
        if (oldFog.fogUnit && oldFog.fogUnit.unitImage instanceof cleverapps.Spine) {
            oldFog.fogUnit.setCascadeOpacityEnabled(false);

            const unitStyles = this.getUnitStyles(this.fogTile.getFakeUnit());

            oldFog.fogUnit.unitImage.runAction(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.FadeTo(0.5, unitStyles.opacity).easing(cc.easeIn(1.5))
            ));
        }
    },

    dispellingDisappearAnimation: function (oldFog, styles) {
        if (this.fogTile.isPointOfInterest()) {
            if (oldFog.fogUnit && oldFog.fogUnit.unitImage) {
                oldFog.fogUnit.unitImage.stopAllActions();
            }

            oldFog.runAction(new cc.Sequence(
                new cc.DelayTime(1),
                new cc.RemoveSelf()
            ));
            return;
        }

        oldFog.fog.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.ScaleTo(0.17, 1.1),
            new cc.ScaleTo(0.17, 0)
        ));

        oldFog.runAction(new cc.Sequence(
            new cc.DelayTime(0.8),
            new cc.FadeOut(0.17),
            new cc.RemoveSelf()
        ));

        const animation = new cleverapps.Spine(bundles.fog_animations.jsons.dispelling);
        animation.setAlignment(styles);
        animation.setCompleteListenerRemove();
        this.addChild(animation);
        animation.replaceParentSamePlace(Map2d.currentMap.getMapView().animations);

        const pseudo = PseudoRandom.GET("fogtile");
        pseudo.seed(this.fogTile.x * 1000 + this.fogTile.y);

        animation.setAnimation(0, pseudo.choose(animation.listAnimations()), false);
    },

    windDisappearAnimation: function (oldFog, styles) {
        oldFog.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.FadeOut(0.5),
            new cc.RemoveSelf()
        ));

        oldFog.fog.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.ScaleTo(0.5, 1.3)
        ));

        oldFog.borders.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.ScaleTo(0.5, 1.3)
        ));

        const animation = new cleverapps.Spine(cleverapps.skins.getSlot("whirlwind"));
        if (styles.timeScale) {
            animation.setTimeScale(styles.timeScale);
        }
        animation.setAnimation(0, "animation", false);
        animation.setAlignment(styles);
        animation.setCompleteListenerRemove();
        this.addChild(animation);
        animation.replaceParentSamePlace(Map2d.currentMap.getMapView().animations);
    },

    plantsDisappearAnimation: function (oldFog) {
        oldFog.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.FadeOut(0.5),
            new cc.RemoveSelf()
        ));

        oldFog.fog.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.Spawn(
                new cc.MoveBy(0.3, 0, 15),
                new cc.ScaleTo(0.3, 1.2).easing(cc.easeBackOut())
            ),
            new cc.MoveBy(0.2, 0, -15)
        ));
    },

    createFakeUnitNode: function (fakeUnit) {
        const unitNode = new cc.Node();

        const shift = cc.p(fakeUnit.shiftX || 0, fakeUnit.shiftY || 0);
        const cellSize = cleverapps.styles.Map2dView.cell;

        unitNode.setAlignment(
            this.tileView.width / 2 + cellSize.width * (shift.x - shift.y) / 2,
            this.tileView.height / 2 + cellSize.height * (shift.x + shift.y) / 2
        );
        unitNode.setCascadeOpacityEnabled(true);
        unitNode.setCascadeColorEnabled(true);

        const unitStyles = this.getUnitStyles(fakeUnit);
        unitNode.setOpacity(unitStyles.opacity);
        unitNode.setColor(unitStyles.color);
        unitNode.setLocalZOrder(unitStyles.zOrder || 0);
        this.tileView.addChild(unitNode);

        const fogUnitAnimation = cleverapps.skins.getSlot("unitFogAnimation", fakeUnit);

        const unitImage = UnitView.getUnitImage(fakeUnit, {
            keepLazy: true,
            alignAnchorX: true,
            defaultAnimation: fogUnitAnimation,
            alignAnchorY: true
        });
        if (unitImage instanceof LazyAsset) {
            unitImage.setCascadeOpacityEnabled(true);
            unitImage.setCascadeColorEnabled(true);
        }

        unitNode.setAnchorPoint(unitImage.anchorX, unitImage.anchorY);
        unitNode.setContentSize(unitImage.getContentSize());
        unitImage.setAnchorPoint(0.5, 0.5);
        unitImage.setAlignment(unitNode.width / 2, unitNode.height / 2);

        if (unitImage.clearTrack) {
            unitImage.setAnimationFrame(0, 0);
            unitImage.clearTrack(0);
        }

        unitNode.unitImage = unitImage;
        unitNode.addChild(unitImage);

        if (fakeUnit.grounded) {
            this.addGroundedCovering(fakeUnit, unitStyles);
        }

        MultiCellView(fakeUnit, unitNode);

        return unitNode;
    },

    addGroundedCovering: function (fakeUnit, unitStyles) {
        const grounded = new cc.Sprite(GroundedView.getImage(fakeUnit.x, fakeUnit.y));
        grounded.setOpacity((unitStyles.opacity * 0.5) % 255);
        grounded.setColor(unitStyles.color);
        grounded.setLocalZOrder((unitStyles.zOrder - 1) || 0);
        this.tileView.addChild(grounded);
        grounded.setAlignment(this.tileView.width / 2, this.tileView.height / 2);
    },

    startFogDisappearAnimation: function (silent) {
        if (this.fogTile.fake) {
            return;
        }

        const styles = this.getStyles();

        let oldFog;
        if (!silent) {
            oldFog = new cc.Node();
            oldFog.setCascadeOpacityEnabled(true);
            oldFog.setContentSize(this.tileView.getContentSize());
            oldFog.setAlignment(this.tileView.width / 2, this.tileView.height / 2);
            oldFog.setAnchorPoint(this.tileView.getAnchorPoint());
            this.addChild(oldFog);
            oldFog.fog = new cc.Node();
            oldFog.fog.setCascadeOpacityEnabled(true);
            oldFog.fog.setAnchorPoint(0.5, 0.5);
            oldFog.fog.setContentSize(oldFog.getContentSize());
            oldFog.fog.setAlignment(oldFog.width / 2, oldFog.height / 2);
            oldFog.addChild(oldFog.fog);
            oldFog.borders = new cc.Node();
            oldFog.borders.setCascadeOpacityEnabled(true);
            oldFog.borders.setAnchorPoint(0.5, 0.5);
            oldFog.borders.setContentSize(oldFog.getContentSize());
            oldFog.borders.setAlignment(oldFog.width / 2, oldFog.height / 2);
            oldFog.borders.setLocalZOrder(-1);
            oldFog.addChild(oldFog.borders);
        }

        if (this.sprite) {
            if (!silent && this.sprite.fogAnimVariant !== undefined) {
                this.sprite.setAnimation(0, `open${this.sprite.fogAnimVariant}`, false);
                this.sprite.setCompleteListenerRemove();
                oldFog.isFogSpine = true;
            } else if (!silent) {
                this.sprite.replaceParent(oldFog.fog);
            } else {
                this.sprite.removeFromParent();
            }
            this.sprite = undefined;
        }
        this.borders.forEach((border) => {
            if (!silent) {
                border.replaceParentSamePlace(oldFog.borders);
            } else {
                border.removeFromParent();
            }
        }, this);
        this.borders = [];
        if (this.fogUnit) {
            if (!silent) {
                oldFog.fogUnit = this.fogUnit;
                this.fogUnit.replaceParentSamePlace(oldFog);
            } else {
                this.fogUnit.removeFromParent();
            }
            this.fogUnit = undefined;
            this.additionalClickView = undefined;
        }

        this.tileView.setAnchorPoint(0.5, 0.5);

        if (Map2d.currentMap.isWaterUnit(this.fogTile.x, this.fogTile.y)) {
            this.sprite = new cc.Node();
        } else {
            const groundFogFrame = this.getGroundFogFrame();
            this.sprite = groundFogFrame ? new cc.Sprite(groundFogFrame) : new cc.Node();
        }

        this.tileView.addChild(this.sprite);

        const offsetX = styles.groundFog && styles.groundFog.offsetX || 0;
        const offsetY = styles.groundFog && styles.groundFog.offsetY || 0;
        this.sprite.setPosition(this.tileView.width / 2 + offsetX, this.tileView.height / 2 + offsetY);
        this.sprite.setLocalZOrder(-1);

        if (this.fogTile.fogBlock.isMoney()) {
            this.sprite.setColor(new cc.Color(255, 150, 255, 255));
            const spine = new cleverapps.Spine(bundles.fog.jsons.buy_fog_tile_json);
            spine.setTimeScale(0.5 + Math.random());
            spine.setAlignment(this.sprite.width / 2, this.sprite.height / 2);
            this.sprite.addChild(spine);
            spine.setAnimation(0, "animation", true);
        } else if (styles.groundFogFx && bundles.fog.jsons.ground_fog_fx_json && (this.fogTile.fogBlock.state === FogBlock.CANTOPEN || this.fogTile.fogBlock.state === FogBlock.CANOPEN)) {
            const pseudo = PseudoRandom.GET("groundfogfx");
            pseudo.seed(this.fogTile.x * 1000 + this.fogTile.y);

            const weighted = Object.entries(styles.groundFogFx).flatMap((entry) => Array(entry[1]).fill(entry[0]));
            const chosenAnimation = pseudo.choose(weighted);

            if (chosenAnimation !== "none" && !this.groundFogFxSpine) {
                const mapView = Map2d.currentMap.getMapView();
                const spine = this.groundFogFxSpine = new cleverapps.Spine(bundles.fog.jsons.ground_fog_fx_json);
                mapView.alignViewInGrid(this.fogTile.x, this.fogTile.y, spine);
                spine.setLocalZOrder(mapView.getFogViewLocalZOrder(0, 0) - 1);
                mapView.cloudsAbove.addChild(spine);
                spine.setAnimation(0, chosenAnimation, true);
                spine.setTrackProgress(pseudo.nextDouble());
            }
        }

        const fakeUnits = Map2d.currentMap.fogs.getFakeUnits(this.fogTile.x, this.fogTile.y);

        if (fakeUnits.length > 0 && !fakeUnits[0].head) {
            const unitNodes = fakeUnits.map((fakeUnit) => this.createFakeUnitNode(fakeUnit));
            if (unitNodes.length === 1) {
                this.unitNode = unitNodes[0];
            } else {
                this.unitNode = unitNodes;
            }
        }

        const fogAsColorForUnits = cleverapps.skins.getSlot("fogAsColorForUnits");

        if (this.fogTile.state === FogBlock.CANTOPEN && fogAsColorForUnits) {
            this.sprite.setVisible(false);
            if (this.unitNode) {
                cleverapps.toArray(this.unitNode).forEach((node) => {
                    node.setColor(fogAsColorForUnits.color);
                    node.setOpacity(fogAsColorForUnits.opacity);
                });
            }
        }

        if (!silent && oldFog) {
            this.oldFogDisappearAnimation(oldFog);
        }
    },

    getStyles: function () {
        return cleverapps.styles.FogTileView[this.fogTile.getFogType()];
    },

    getFogImage: function () {
        let images;

        if (cleverapps.environment.isEditorScene()) {
            images = [bundles.fog.frames.fog_editor_png];
        } else {
            const fogBundle = this.fogTile.getFogBundle();
            const textures = [1, 2, 3, 4].map((num) => `fog${num}_png_${this.fogTile.getFogKey()}`);
            images = textures.map((texture) => fogBundle.frames[texture]).filter(Boolean);
        }

        if (images.length === 1) {
            return images[0];
        }

        const pseudo = PseudoRandom.GET("fogtile");
        pseudo.seed(this.fogTile.x * 1000 + this.fogTile.y);
        return pseudo.choose(images);
    },

    getGroundFogFrame: function () {
        const bundle = this.fogTile.getFogBundle();
        if (!bundle) {
            return undefined;
        }
        const type = this.fogTile.getFogKey();

        let images = [];

        if (this.fogTile.fogBlock.isMoney()) {
            images = ["money_ground_fog_png_", "money_ground_fog1_png_", "money_ground_fog2_png_", "money_ground_fog3_png_"].map((frame) => bundle.frames[frame + type]).filter(Boolean);
        }

        if (images.length === 0) {
            images = ["ground_fog_png_", "ground_fog1_png_", "ground_fog2_png_", "ground_fog3_png_"].map((frame) => bundle.frames[frame + type]).filter(Boolean);
        }

        if (images.length === 1) {
            return images[0];
        }

        const pseudo = PseudoRandom.GET("fogtile");
        pseudo.seed(this.fogTile.x * 1000 + this.fogTile.y);
        return pseudo.choose(images);
    },

    updateBorders: function (silent) {
        const styles = this.getStyles();
       
        if (this.getFogSpineJson()) {
            return;
        }

        if (this.borders.length || cleverapps.config.editorMode || this.fogTile.fake || styles.noBorder) {
            return;
        }

        const isPoi = this.fogTile.isPointOfInterest();
        if (isPoi && (this.noPoiFog() || !styles.bordersEverywhere)) {
            return false;
        }

        if (!styles.bordersEverywhere && this.fogTile.state !== FogBlock.NOTREADY) {
            return false;
        }
        
        const fogKey = this.fogTile.getFogKey();
        const bundle = this.fogTile.getFogBundle();

        const borders = this.fogTile.getBorders();
        if (!borders.length) {
            return;
        }

        borders.forEach((border) => {
            const res = bundle.frames && bundle.frames[`fog_${border.dir}_png_${fogKey}`] || border.res;
            const borderView = new cc.Sprite(res);
            this.tileView.addChild(borderView);
            borderView.setAlignment(styles.borders[border.dir]);
            borderView.setLocalZOrder(styles.borders[border.dir].zOrder);
            this.borders.push(borderView);

            if (!silent) {
                cleverapps.effects.fire(`fog.show_borders.${fogKey}`);
            }
        });
    },

    clickAnimation: function () {
        let clickView = this.clickView = this;
        if (this.state === FogTileView.GROUND_STATE) {
            clickView = this.clickView = this.sprite || this.fogUnit;
        }

        const state = this.fogTile.state;
        let tintColor = 230;
        if (state === FogBlock.CANTOPEN || state === FogBlock.CANOPEN) {
            tintColor = 210;
        }
        const iteration1 = new cc.Sequence(
            new cc.TintTo(0.3, tintColor, tintColor, tintColor),
            new cc.TintTo(0.3, 255, 255, 255)
        );
        const iteration2 = new cc.Sequence(
            new cc.TintTo(0.3, tintColor, tintColor, tintColor),
            new cc.TintTo(0.3, 255, 255, 255)
        );

        this.stopClickAction();
        this.stopAdditionalClickAction();

        this.clickAction = clickView.runAction(new cc.Sequence(
            iteration1,
            iteration1,
            iteration1,
            iteration1,
            iteration1
        ));

        if (this.additionalClickView) {
            this.additionalClickAction = this.additionalClickView.runAction(new cc.Sequence(
                iteration2,
                iteration2,
                iteration2,
                iteration2,
                iteration2
            ));
        }
    },

    onOpen: function (callback, silent) {
        callback = callback || function () {};

        const duration = 0.6 * Map2d.animationsTimeScale();

        this.fogTile.clear();

        if (silent) {
            callback();
            this.removeFromParent();
            return;
        }

        if (this.sprite) {
            this.sprite.stopAllActions();
            this.sprite.runAction(new cc.FadeOut(duration));
        }

        if (this.border) {
            this.border.stopAllActions();
            this.border.runAction(new cc.FadeOut(duration));
        }

        this.openFogAction = this.runAction(new cc.Sequence(
            new cc.DelayTime(duration),
            new cc.RemoveSelf()
        )).setFinalize(callback);
    },

    destructFog: function () {
        const animation = new cleverapps.Spine(bundles.merge_animations.jsons.destruction_json);
        animation.setAlignment(this.width / 2, this.height / 2);
        animation.setAnimation(0, "animation", false);
        this.addChild(animation);

        animation.replaceParentSamePlace(this);

        cleverapps.effects.fire("merge.unit.destroy");

        this.destructFogAction = this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.3, 1.3).easing(cc.easeIn(1)),
            new cc.ScaleTo(0.2, 0.5, 0.5).easing(cc.easeOut(1)),
            new cc.RemoveSelf()
        ));
    },

    addBalloon: function () {
        if (this.balloon || !this.fogTile.balloon) {
            return;
        }

        let FogBalloonViewClass = FogBalloonView;
        if (cleverapps.config.editorMode && typeof EditorFogBalloonView !== "undefined") {
            FogBalloonViewClass = EditorFogBalloonView;
        }

        const mapView = Map2d.currentMap.getMapView();
        const balloon = this.balloon = new FogBalloonViewClass(this.fogTile.balloon);

        mapView.cloudsAbove.addChild(balloon);
    },

    clearAnimations: function () {
        this.stopClickAction();
        this.stopAdditionalClickAction();

        if (this.openFogAction && !this.openFogAction.isDone()) {
            this.stopAction(this.openFogAction);
            delete this.openFogAction;
        }
        if (this.fogDisappearAction && !this.fogDisappearAction.isDone()) {
            this.stopAction(this.fogDisappearAction);
            delete this.fogDisappearAction;
        }
        if (this.destructFogAction && !this.destructFogAction.isDone()) {
            this.stopAction(this.destructFogAction);
            delete this.destructFogAction;
        }
    },

    stopClickAction: function () {
        if (this.clickView && this.clickAction && !this.clickAction.isDone()) {
            this.clickView.stopAction(this.clickAction);
            this.clickView.setColor(new cc.Color(255, 255, 255, 255));
        }
    },

    stopAdditionalClickAction: function () {
        if (this.additionalClickView && this.additionalClickAction && !this.additionalClickAction.isDone()) {
            this.additionalClickView.stopAction(this.additionalClickAction);
            this.additionalClickView.setColor(new cc.Color(255, 255, 255, 255));
        }
    }
});

FogTileView.FULL_STATE = 0;
FogTileView.GROUND_STATE = 1;

cleverapps.styles.FogTileView = {
    fogUnits: {
        "default": {
            color: new cc.Color(0, 150, 255, 255),
            opacity: 120
        }
    },

    moneyFogUnits: {
        "default": {
            color: new cc.Color(255, 100, 100, 255),
            opacity: 120
        }
    }
};

cleverapps.styles.FogTileView["medieval"] = {
    anchorX: 0.5,
    anchorY: 0.22,

    bordersEverywhere: true,

    pointsOfInterest: {
        center: true,
        animation: "idle_fog"
    },

    borders: {
        center: {
            x: { align: "center", dx: 1 },
            y: { align: "center", dy: -13 },
            zOrder: 0
        },
        left: {
            x: { align: "left", dx: -12 },
            y: { align: "bottom", dy: -32 },
            zOrder: 0
        },
        down: {
            x: { align: "right", dx: 10 },
            y: { align: "bottom", dy: -36 },
            zOrder: 0
        },
        up: {
            x: { align: "left", dx: -12 },
            y: { align: "top", dy: 4 },
            zOrder: 0
        },
        right: {
            x: { align: "right", dx: 16 },
            y: { align: "top", dy: 10 },
            zOrder: 0
        }
    },

    whirlwind: {
        duration: 500,
        timeScale: 1.5,
        x: { align: "center", dx: 35 },
        y: { align: "center", dy: 25 }
    }
};

cleverapps.styles.FogTileView["medieval_green"] = cleverapps.styles.FogTileView["medieval_ice"] = cleverapps.styles.FogTileView["medieval_purple"] = cleverapps.styles.FogTileView["medieval_sand"] = cleverapps.styles.FogTileView["medieval_blue"] = {
    anchorX: 0.5,
    anchorY: 0.22,

    noBorder: true,

    borders: {
        center: {
            x: { align: "center", dx: 1 },
            y: { align: "center", dy: -13 },
            zOrder: 0
        }
    },

    pointsOfInterest: {
        center: true,
        animation: "idle_fog"
    },

    whirlwind: {
        duration: 500,
        timeScale: 1.5,
        x: { align: "center", dx: 35 },
        y: { align: "center", dy: 25 }
    }
};

cleverapps.styles.FogTileView["tropicislands"] = {
    anchorX: 0.5,
    anchorY: 0.22,

    fogDecors: {
        decorator_firefly: 1,
        decorator_sparkly: 1,
        none: 18
    },

    groundFogFx: {
        animation: 1,
        butterfly: 1,
        none: 18
    },

    pointsOfInterest: {
        center: false,
        animation: false
    },

    borders: {
        center: {
            x: { align: "center", dx: -5 },
            y: { align: "center", dy: -10 },
            zOrder: 10
        },
        left: {
            x: { align: "left", dx: -10 },
            y: { align: "bottom", dy: -33 },
            zOrder: 11
        },
        down: {
            x: { align: "right", dx: 12 },
            y: { align: "bottom", dy: -34 },
            zOrder: 11
        },
        up: {
            x: { align: "left", dx: -9 },
            y: { align: "top", dy: 16 },
            zOrder: 9
        },
        right: {
            x: { align: "right", dx: 12 },
            y: { align: "top", dy: 16 },
            zOrder: 9
        }
    }
};

cleverapps.styles.FogTileView["fairyland"] = {
    anchorX: 0.5,
    anchorY: 0.22,

    fogDecors: {
        decorator_firefly: 1,
        decorator_sparkly: 1,
        none: 18
    },

    groundFogFx: {
        animation: 2,
        butterfly: 1,
        none: 17
    },

    pointsOfInterest: {
        center: false,
        animation: false,
        likeGroundState: true
    },

    borders: {
        center: {
            x: { align: "center", dx: -2 },
            y: { align: "center", dy: -12 },
            zOrder: 10
        },
        left: {
            x: { align: "left", dx: -18 },
            y: { align: "bottom", dy: -29 },
            zOrder: 11
        },
        down: {
            x: { align: "right", dx: 9 },
            y: { align: "bottom", dy: -30 },
            zOrder: 11
        },
        up: {
            x: { align: "left", dx: -17 },
            y: { align: "top", dy: 36 },
            zOrder: 9
        },
        right: {
            x: { align: "right", dx: 9 },
            y: { align: "top", dy: 36 },
            zOrder: 9
        }
    },

    dispelling: {
        duration: 1200,
        x: { align: "center", dx: -2 },
        y: { align: "center", dy: 30 }
    }
};

cleverapps.styles.FogTileView["cloudislands"] = {
    anchorX: 0.49,
    anchorY: 0.9,

    pointsOfInterest: {
        center: false
    },

    borders: {
        center: {
            x: { align: "center" },
            y: { align: "center", dy: 55 },
            zOrder: 0
        }
    }
};

cleverapps.styles.FogTileView["seabottom"] = {
    anchorX: 0.5,
    anchorY: 0.5,

    pointsOfInterest: {
        center: false
    },

    borders: {
        center: {
            x: { align: "center" },
            y: { align: "center", dy: 10 },
            zOrder: 0
        }
    }
};

cleverapps.styles.FogTileView["heroes"] = {
    anchorX: 0.5,
    anchorY: 0.22,

    pointsOfInterest: {
        center: true,
        animation: "idle_fog"
    },

    borders: {
        center: {
            x: { align: "center", dx: -2 },
            y: { align: "center", dy: -12 },
            zOrder: 10
        },
        left: {
            x: { align: "left", dx: -18 },
            y: { align: "bottom", dy: -29 },
            zOrder: 11
        },
        down: {
            x: { align: "right", dx: 9 },
            y: { align: "bottom", dy: -30 },
            zOrder: 11
        },
        up: {
            x: { align: "left", dx: -17 },
            y: { align: "top", dy: 36 },
            zOrder: 9
        },
        right: {
            x: { align: "right", dx: 9 },
            y: { align: "top", dy: 36 },
            zOrder: 9
        }
    },

    dispelling: {
        duration: 1200,
        x: { align: "center", dx: -2 },
        y: { align: "center", dy: 30 }
    }
};

cleverapps.styles.FogTileView["adventure"] = {
    anchorX: 0.5,
    anchorY: 0.5,

    groundStateOnly: true,

    pointsOfInterest: {
        center: false,
        animation: false
    },

    unitStyles: {
        color: new cc.Color(255, 255, 255, 255),
        opacity: 255,
        zOrder: -2
    },

    groundFog: {
        offsetY: 30
    },

    borders: {
        center: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 },
            zOrder: 0
        }
    }
};

cleverapps.styles.FogTileView["homefix"] = {
    anchorX: 0.5,
    anchorY: 0.22,

    groundStateOnly: true,
    noBorder: true,

    pointsOfInterest: {
        center: true,
        animation: "idle_fog"
    },

    groundFog: {
        offsetY: 218
    }
};

cleverapps.styles.FogTileView["hearts"] = {
    anchorX: 0.5,
    anchorY: 0.22,

    bordersEverywhere: true,

    pointsOfInterest: {
        center: true,
        animation: "idle_fog"
    },

    borders: {
        center: {
            x: { align: "center", dx: 1 },
            y: { align: "center", dy: -13 },
            zOrder: 0
        },
        left: {
            x: { align: "left", dx: -12 },
            y: { align: "bottom", dy: -32 },
            zOrder: 0
        },
        down: {
            x: { align: "right", dx: 10 },
            y: { align: "bottom", dy: -36 },
            zOrder: 0
        },
        up: {
            x: { align: "left", dx: -12 },
            y: { align: "top", dy: 4 },
            zOrder: 0
        },
        right: {
            x: { align: "right", dx: 16 },
            y: { align: "top", dy: 10 },
            zOrder: 0
        }
    },

    whirlwind: {
        duration: 500,
        timeScale: 1.5,
        x: { align: "center", dx: 35 },
        y: { align: "center", dy: 25 }
    }
};

cleverapps.styles.FogTileView["asia"] = cleverapps.styles.FogTileView["castle"] = cleverapps.styles.FogTileView["medieval"];

cleverapps.styles.FogTileView["coloredseabottom"] = cleverapps.styles.FogTileView["seabottom"];

cleverapps.styles.FogTileView["tomb"] = cleverapps.styles.FogTileView["cloudislands"];

// eslint-disable-next-line max-len
cleverapps.styles.FogTileView["parkland"] = cleverapps.styles.FogTileView["july4"] = cleverapps.styles.FogTileView["startale"] = cleverapps.styles.FogTileView["summerpets"] = cleverapps.styles.FogTileView["winter"] = cleverapps.styles.FogTileView["adventureny"] = cleverapps.styles.FogTileView["adventurevd"] = cleverapps.styles.FogTileView["patrickday"] = cleverapps.styles.FogTileView["musicfest"] = cleverapps.styles.FogTileView["spring"] = cleverapps.styles.FogTileView["laborday"] = cleverapps.styles.FogTileView["testadv"] = cleverapps.styles.FogTileView["earthday"] = cleverapps.styles.FogTileView["adventure"];

cleverapps.styles.FogTileView["0"] = cleverapps.styles.FogTileView["homefix"];

cleverapps.styles.FogTileView["garden"] = {
    anchorX: 0.5,
    anchorY: 0.5,

    noBorder: true,

    borders: {
        center: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 },
            zOrder: 0
        }
    }
};